<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="listReview" class="container ">
    <div class="row justify-content-center">
        <div class="col-8">
            <h2 class="lifedi-color text-center m-3">
                {{ listReview.COURSE_NAME }}

            </h2>
        </div>
    </div>

    <div class="row text-left overflow-hidden" style="margin-bottom: 20px;">
        <div class="col-12">
            <ng-template #r let-fill="fill">
                <span class="star" [class.full]="fill === 100">
                    <span class="half" [style.width.%]="fill">&#x2605;</span>&#x2605;
                </span>
            </ng-template>
            <ngb-rating [(rate)]="point.AVERAGE_POINT" [starTemplate]="r" readonly="true" [max]="point.MAX_POINT">
            </ngb-rating>

            <span class="title" *ngIf="point.AVERAGE_POINT !== 0"
                style="margin-left: 10px; margin-top: 2px; font-weight: bold;">
                {{ point.AVERAGE_POINT | number:'1.1-1'}}/{{ point.MAX_POINT }}
                ({{ point.TOTAL_REVIEW }} รีวิว)
            </span>
            <span *ngIf="point.AVERAGE_POINT === 0" style="margin-left: 10px; margin-top: 2px; font-weight: bold;">
                {{ point.AVERAGE_POINT }}/{{ point.MAX_POINT }} ({{ point.TOTAL_REVIEW }} รีวิว)
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 justify-content-center">
            <div *ngIf="allReview.length === 0">
                <h3 class="col-12 text-center" style="margin: 20px 0; color: rgb(0, 0, 0);">ยังไม่มีการเขียนรีวิว</h3>
            </div>
        </div>
    </div>

    <div *ngIf="allReview.length > 0">
        <mat-card *ngFor="let list of allReview" class="row mb-3" style="padding-top: 0;">

            <!-- mobile size -->
            <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
                <div class="col-12 text-center inline-block mb-3">
                    <div style="margin: 5px 0 0; width: fit-content;">
                        <img width="50px" height="50px" style="border-radius: 50%; margin-top: 30px;"
                            [src]="list.IMAGE_PROFILE">
                        <div class="ml-3" style="display: inline-table;">
                            <ngb-rating class="mt-2" [(rate)]="list.REVIEW_POINT" readonly="true" max="5"
                                style="color: #ffc107;">
                            </ngb-rating>
                            <p>{{ list.USERNAME }}</p>
                        </div>
                    </div>
                </div>
                <span class="d-block d-sm-block d-md-block" style="display: inline; float: right;">
                    <a (click)="delete(list.REVIEW_ID, list.REVIEW_MESSAGE)">
                        <img src="../../../../assets/bin.png" alt=""
                            style="width: 20px; position: absolute; right: 30px; top: 20px;">
                    </a>
                </span>
                <div class="col-12 inline-block">
                    {{ list.REVIEW_MESSAGE }}
                </div>
            </mat-card-content>

            <!-- desktop size -->
            <mat-card-content style="padding-bottom: 10px"
                class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
                <div class="col-lg-2 col-md-2 col-sm-3 col-4 text-center inline-block">
                    <div style="margin: 5px auto 0; width: fit-content;">
                        <img width="50px" height="50px" style="border-radius: 50%; margin-top: 30px;"
                            [src]="list.IMAGE_PROFILE"><br />
                        <ngb-rating class="mt-2" [(rate)]="list.REVIEW_POINT" readonly="true" max="5"
                            style="color: #ffc107;">
                        </ngb-rating><br>
                        <p>{{ list.USERNAME }}</p>
                    </div>
                </div>
                <span class="d-block d-sm-block d-md-block" style="display: inline; float: right;">
                    <a (click)="delete(list.REVIEW_ID, list.REVIEW_MESSAGE)">
                        <img src="../../../../assets/bin.png" alt=""
                            style="width: 20px; position: absolute; right: 30px; top: 20px;">
                    </a>
                </span>
                <div class="col-lg-10 col-md-10 col-sm-9 col-8 inline-block">
                    {{ list.REVIEW_MESSAGE }}
                </div>
            </mat-card-content>
            <mat-card-footer style="position: absolute; right: 50px; bottom: 30px;">
                {{ list.REVIEW_DATE | date }}
            </mat-card-footer>
        </mat-card>
    </div>
</div>